import type { ReactNode } from "react";
import styles from "./IconItem.module.css";

interface Props {
  icon: ReactNode;
  children: ReactNode;
}

export default function IconItem({ icon, children }: Props) {
  return (
    <div className={styles.IconItem}>
      <div className={styles.IconItemIcon}>{icon}</div>
      {children}
    </div>
  );
}
